module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10024.37b38a25.jpg";